import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from './../authentication/authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationGuard  {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
			const currentUser = this.authenticationService.currentUserValue;
			if (currentUser) {
				return true;
			}
			this.router.navigate(['/account/login'], { queryParams: route.queryParams});
			return false;
		}
}